var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoRecordsImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 114",
    cx: 80,
    cy: 80,
    r: 80,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 138",
    cx: 65.6795,
    cy: 74.0156,
    r: 31.6667,
    transform: "rotate(-45 65.6795 74.0156)",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2655"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M59.3334 67.1203C59.8557 65.6354 60.8868 64.3832 62.2439 63.5857C63.6009 62.7881 65.1965 62.4965 66.748 62.7626C68.2994 63.0288 69.7066 63.8354 70.7204 65.0396C71.7341 66.2438 72.2889 67.768 72.2866 69.3421C72.2866 73.7857 65.6211 76.0075 65.6211 76.0075",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M65.8047 84.3333H65.8211",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1313",
    d: "M110.515 111.443L119.463 120.391C121.415 122.344 121.415 125.509 119.463 127.462V127.462C117.51 129.415 114.344 129.415 112.392 127.462L93.5355 108.606C91.5829 106.653 91.5829 103.487 93.5355 101.535V101.535C95.4882 99.5822 98.654 99.5822 100.607 101.535L103.793 104.721",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 131",
    d: "M86.8906 95.2266L93.9617 102.298",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 2410"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M136.589 68.3359L134.014 70.9111",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 52",
    d: "M127.579 77.3463L125.004 79.9215",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 53",
    d: "M136.589 79.9245L134.014 77.3493",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 54",
    d: "M127.579 70.9141L125.004 68.3389",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 140",
    cx: 63.071,
    cy: 132.071,
    r: 3.33333,
    transform: "rotate(45 63.071 132.071)",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 139",
    cx: 93.7369,
    cy: 28.7378,
    r: 3.33333,
    transform: "rotate(45 93.7369 28.7378)",
    stroke: "#FF6C6C",
    strokeWidth: 3.33333
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoRecordsImage);
export default __webpack_public_path__ + "static/media/no-records-image.dc06f0bc.svg";
export { ForwardRef as ReactComponent };